import { render, staticRenderFns } from "./quill-editor.vue?vue&type=template&id=acb970ac&scoped=true"
import script from "./quill-editor.vue?vue&type=script&lang=js"
export * from "./quill-editor.vue?vue&type=script&lang=js"
import style0 from "./quill-editor.vue?vue&type=style&index=0&id=acb970ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb970ac",
  null
  
)

export default component.exports